import { render, staticRenderFns } from "./priceDescription.vue?vue&type=template&id=c72e71f8&scoped=true&"
import script from "./priceDescription.vue?vue&type=script&lang=js&"
export * from "./priceDescription.vue?vue&type=script&lang=js&"
import style0 from "./priceDescription.vue?vue&type=style&index=0&id=c72e71f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72e71f8",
  null
  
)

export default component.exports